export default __webpack_public_path__ + "static/media/scroll6.1e949dd7.jpg";